import { CommonModule } from '@angular/common';
import { DateTodayComponent } from './datetoday.component';
import { NgModule } from "@angular/core";

@NgModule({
    declarations: [
        DateTodayComponent,
    ],
    exports: [
        DateTodayComponent,
    ],
    imports: [
        CommonModule
    ]
})
export class DateTodayModule {
}